<template>
  <VCardText>
    <slot />
  </VCardText>
</template>

<script setup lang="ts">
import { VCardText } from 'vuetify/components/VCard';
</script>
